<script lang="ts">
    import {Component, Prop, Setup, toNative} from 'vue-facing-decorator'
    import CompanyAutocomplete, {
        CompanyAutocomplete as _CompanyAutocomplete,
    } from '@/components/account/modals/newOrderRequest/CompanyAutocomplete.vue'

    @Component({mixins: [CompanyAutocomplete]})
    export class CustomerCompanySelectAutocomplete extends _CompanyAutocomplete {
        @Prop({required: false, default: 'CLIENT', type: String}) relationship
        @Setup(() => useLocalized()) localized: Function

        async loadClients() {
            try {
                this.clients = []
                this.cancelTokenSources.forEach(cancelTokenSource => cancelTokenSource.cancel())
                this.cancelTokenSources = []
                this.isLoadingClients = true

                const cancelTokenSource = this.$axios.CancelToken.source()
                this.cancelTokenSources.push(cancelTokenSource)

                const rq = {
                    relationship: this.relationship,
                    shortResponse: true,
                    limit: 10,
                    name: this.searchInput,
                }

                this.clients = (await this.$api.companies.get(rq, cancelTokenSource.token)).companies.sort((a, b) =>
                    a.name.localeCompare(b.name)
                )
            } catch (e) {
                /* empty */
            } finally {
                this.isLoadingClients = false
            }
        }
    }

    export default {...toNative(CustomerCompanySelectAutocomplete), ssrRender: CompanyAutocomplete.ssrRender}
</script>
